export const PINNED_FIELDS_SORTABLE_ID =
	'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
export const VISIBLE_FIELDS_SORTABLE_ID =
	'issue-view-layout-templates-views.ui.context.visible-hidden.ui.visible-fields';
export const HIDDEN_FIELDS_SORTABLE_ID =
	'issue-view-layout-templates-views.ui.context.visible-hidden.ui.hidden-fields';

export const CONTEXT_GROUP_INITIAL_OPENED = false;
export const ISSUE_FIELD_SPOTLIGHT_PREFIX = 'global-spotlight-target-' as const;
export const STATUS_AND_APPROVAL_SPOTLIGHT = 'status-and-approval-spotlight' as const;
